import {
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../../../components/ui/dialog";
import { Button } from "../../../../components/ui/button";
import React, { Fragment } from "react";
import { toast } from "sonner";
import { vetTenant } from "../../../Admin/Tenants";
import { TenantAdminInterface } from "../../../../types/Central";

export interface AcceptActionInterface {
    row: TenantAdminInterface;
    onClose: () => void;
}

export function AcceptAction({ row, onClose }: AcceptActionInterface) {
    async function handleSubmit() {
        try {
            await vetTenant(row, true);

            onClose();
            toast.message(`Approved ${row.id}`);
        } catch (e) {
            toast.error("Something went wrong while approve the tenant");
        }
    }

    return (
        <Fragment>
            <DialogHeader>
                <DialogTitle>Accept {row.id}</DialogTitle>
                <DialogDescription>Are you sure?</DialogDescription>
            </DialogHeader>
            <DialogFooter className="mt-4">
                <Button type="button" onClick={onClose} variant="default">
                    Cancel
                </Button>
                <Button type="submit" onClick={handleSubmit} variant="destructive">
                    Submit
                </Button>
            </DialogFooter>
        </Fragment>
    );
}
